<template>
  <div class="col-12">
    <chart-card title="Reported Cases Stacked Line Chart"
                sub-title="Group Case by different categories"
                v-if="!isFetchingReportedCasesLine"
                :chart-data="data"
                :chart-options="options"
                footer-text='Last Two weeks (Default)'
    >
      <div v-if="!data || data.series.length === 0" slot="empty">No Data Available</div>
      <div class="row" slot="filter">
        <div class="col-6">
          <div class="dropdown menu">
            <button class="btn btn-round btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Filter
            </button>
            <div class="dropdown-menu dropdown-menu-right p4 ">
              <form class="col-12" @submit.prevent>
                <fg-input-dropdown type="text"
                                   label="Group By"
                                   placeholder="e.g Nature"
                                   required
                                   :options="tagOptions"
                                   v-model="tag">
                </fg-input-dropdown>
                <date-range-picker
                  v-model="dateRange"
                  ref="picker"
                  :minDate="minDate"
                  :maxDate="maxDate"
                  opens="right"
                  :locale-data="locale"
                  @update="updateValues"
                >
                  <template v-slot:input="picker" style="min-width: 50px;">
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </template>
                </date-range-picker>
                <br />
                <p-button type="success"
                          style="margin-left: auto; display: block;"
                          round
                          @click.native.prevent="fetchWithFilter">
                  Submit
                </p-button>
                <br />
              </form>
            </div>
          </div>
        </div>
      </div>
    </chart-card>
  </div>
</template>
<script>
import {
  mapState,
  mapActions,
} from 'vuex';
import moment from 'moment';
import Chartist from 'chartist';
require('chartist-plugin-legend');
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import { ChartCard } from "@/components/index";
import { getCounsellor } from '@/utils/auth'
import {
  minDate,
  nowDate,
  twoWeekStartDate,
  twoWeekEndDate,
  isOneDay,
  isMoreThanAMonth
} from "@/utils/utils";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  components: {
    ChartCard,
    DateRangePicker
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      counsellor: null,
      minDate: minDate(),
      maxDate: nowDate(),
      dateRange: {
        startDate: twoWeekStartDate(),
        endDate: twoWeekEndDate()
      },
      locale: {
        direction: 'ltr',
        format: 'mm-dd-yyyy',
        separator: ' to ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 1
      },
      tag: 'Nature',
      tagOptions: [
        {key: 0, value: "Nature", text: "Case Nature"},
        {key: 1, value: "LGA", text: "Local Government Area"},
        {key: 2, value: "CallHandlerUuid", text: "Call Handler"},
        {key: 3, value: "PerpetratorEmploymentStatus", text: "Perpetrator Employment Status"},
        {key: 4, value: "PerpetratorGender", text: "Perpetrator Gender"},
        {key: 5, value: "PerpetratorRelationship", text: "Perpetrator Relationship"},
        {key: 6, value: "PerpetratorAgeRange", text: "Perpetrator Age Range"},
        {key: 7, value: "SurvivorGender", text: "Survivor Gender"},
        {key: 8, value: "SurvivorMaritalStatus", text: "Survivor Marital Status"},
        {key: 9, value: "SurvivorEmploymentStatus", text: "Survivor Employment Status"},
        {key: 10, value: "ReporterType", text: "Reporter Type"},
        {key: 11, value: "ReporterGender", text: "Reporter Gender"},
        {key: 12, value: "ReferredBy", text: "Referred By"},
        {key: 13, value: "Status", text: "Case Status"},
      ],
      config: {
        format: '',
        useCurrent: false,
        showClear: true,
        showClose: true,
      },
      legendNames: [],
      filter: {
        workspaceId: null,
        tag: 'Nature',
        start_absolute: twoWeekStartDate(),
        end_absolute: twoWeekEndDate(),
      },
      countLineData: null,
      data: null,
      options: null,
    };
  },
  filters: {
    date(val) {
      return val ? moment(val).format('LL') : "";
    }
  },
  computed: {
    ...mapState('analytics', ['reportedCasesLine', 'isFetchingReportedCasesLine']),
    ...mapState("auth", [
      "allCounsellorList",
      "isFetchingAllCounsellorList",
    ]),
  },
  watch: {
    async reportedCasesLine(newValue) {
      await this.formatGraphData(newValue);
    },
    tag(newValue) {
      this.filter.tag = newValue;
    }
  },
  async mounted() {

  },
  async created() {
    this.counsellor = getCounsellor();
    await this.fetchAllCounsellorList(this.counsellor.workspaceId);
    await this.fetchWithFilter()
  },
  methods: {
    ...mapActions('analytics', [
      'fetchReportedCasesLine',
    ]),
    ...mapActions('auth', [
      'fetchAllCounsellorList'
    ]),
    updateValues({ startDate, endDate }) {
      this.filter.start_absolute = startDate;
      this.filter.end_absolute = endDate;
    },
    async fetchWithFilter() {
      this.filter.workspaceId = this.counsellor.workspaceId;

      const params = this.filter;
      Object.keys(params).forEach((key) => (params[key] === null || params[key] === '') && delete params[key]);

      if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
        const stateDate = moment(this.filter.start_absolute)
        const endDate = moment(this.filter.end_absolute)
        this.filter.start_absolute = stateDate.startOf('day').valueOf()
        this.filter.end_absolute = endDate.endOf('day').valueOf()
      }
      else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
        const stateDate = moment(this.filter.start_absolute)
        const endDate = moment(this.filter.end_absolute)
        this.filter.start_absolute = stateDate.startOf('month').valueOf()
        this.filter.end_absolute = endDate.endOf('month').valueOf()
      }
      else {
        const stateDate = moment(this.filter.start_absolute)
        const endDate = moment(this.filter.end_absolute)
        this.filter.start_absolute = stateDate.startOf('day').valueOf()
        this.filter.end_absolute = endDate.endOf('day').valueOf()
      }

      // console.log("PARAMS", JSON.stringify(params))
      await this.fetchReportedCasesLine(params);
    },
    removeDuplicates(arr) {
      return [...new Set(arr)];
    },
    getExpectedTimeStamps (start, end) {
      const expectedTimeStamps = [];
      const startDate          = moment(start);
      const endDate            = moment(end);
      if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
        while (startDate.isBefore(endDate)) {
          expectedTimeStamps.push(startDate.format('h:mm a'));
          startDate.add(1, 'hours');
        }
      }
      else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
        while (startDate.isBefore(endDate)) {
          expectedTimeStamps.push(startDate.format('MMMM YYYY'));
          startDate.add(1, 'months');
        }
      }
      else {
        while (startDate.isBefore(endDate)) {
          expectedTimeStamps.push(startDate.format('YYYY-MM-DD'));
          startDate.add(1, 'days');
        }
      }
      return expectedTimeStamps;
    },
    async formatGraphData() {
      this.data = {
        labels: [],
        series: []
      }
      this.legendNames = []
      this.options = {
        low: 0,
        showArea: false,
        height: "350px",
        axisX: {
          showGrid: true
        },
        axisY: {
          onlyInteger: true,
          showGrid: true
        },
        labelOffset: 70,
        labelDirection: 'explode',
        showLine: true,
        pointRadius: 0.3,
        pointHoverRadius: 0.3,
        plugins: [
          Chartist.plugins.tooltip(),
          ChartistTooltip(),
          Chartist.plugins.legend({
            position: 'bottom',
            legendNames: this.legendNames,
          })
        ]
      }
      const expectedTimeStamps = this.getExpectedTimeStamps(
        this.filter.start_absolute,
        this.filter.end_absolute
      );
      expectedTimeStamps.forEach((timestamp, idx) => {
        if (!this.data.labels.includes(timestamp)) this.data.labels.push(timestamp);
      });
      // console.log("EXPECTED", expectedTimeStamps)
      this.reportedCasesLine.forEach(query => {

        const resultTimestamps = this.removeDuplicates(query.entries.map(entry => {
          if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
            return moment(entry.created).startOf('hour').format('h:mm a')
          }
          else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
            return moment(entry.created).format('MMMM YYYY')
          }
          else {
            return moment(entry.created).format('YYYY-MM-DD')
          }
        }));

        // console.log("RESULT", resultTimestamps)

        if (this.tag === 'CallHandlerUuid') {
          const agent = this.allCounsellorList.find(c => c.id.toString() === query.tag.toString());
          agent ? this.legendNames.push(agent.name) : this.legendNames.push(query.tag)
        } else {
          this.legendNames.push(query.tag);
        }

        const groupCountByAge = query.entries.reduce((group, entry) => {
          if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
            const timestamp = moment(entry.created).startOf('hour').format('h:mm a');
            const count = group[timestamp] || 0;
            group[timestamp] = count + 1;
            return group;
          }
          else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
            const timestamp = moment(entry.created).format('MMMM YYYY');
            const count = group[timestamp] || 0;
            group[timestamp] = count + 1;
            return group;
          }
          else {
            const timestamp = moment(entry.created).format('YYYY-MM-DD');
            const count = group[timestamp] || 0;
            group[timestamp] = count + 1;
            return group;
          }
        }, {});

        const elements = [];
        expectedTimeStamps.forEach((timestamp, idx) => {
          if (resultTimestamps.includes(timestamp)) {
            elements.push(groupCountByAge[timestamp]);
          } else {
            elements.push(0);
          }
        });
        this.data.series.push(elements);
      })
      // console.log("LEGEND NAME  ", JSON.stringify(this.legendNames))
      // console.log("DATATATA ", JSON.stringify(this.data))
    }
  }
}
</script>
<style lang="scss" scoped>
.menu.dropdown {
  margin-bottom: 15px;
  z-index: 9;
}
.upper {
  z-index: 1000;
}
</style>
